import { useMemo, useState, useEffect } from 'react'

import { useAuthContext } from '@eqworks/common-login'
import { useQuery } from 'react-query'
import { toast } from 'material-react-toastify'

import getAxios from '../helpers/axios/api'
import { checkUserRoles } from '../helpers/utils'

export const useAccess = () => {
  const { authState: { access } } = useAuthContext()
  const roles = useMemo(() => (
    Object.fromEntries(
      checkUserRoles(access).map(r => [r, true])
    )
  ), [access])
  return {
    ...access,
    roles,
  }
}

export const useWhiteLabels = () => {
  const _key = 'Get White Labels'
  const { isError, error, isLoading, data = [] } = useQuery(
    _key,
    () => getAxios().get('/whitelabel').then(({ data = [] }) => data),
  )

  useEffect(() => {
    if (isError) {
      toast.error(`${_key}: ${error.message}`)
    }
  }, [isError, error])

  return [isLoading, data]
}

export const useCustomers = (wlID) => {
  const _key = 'Get Customers'
  const { isError, error, isLoading, data = [] } = useQuery(
    [_key, wlID],
    () =>  getAxios().get('/customer', { params: { wlID } }).then(({ data = [] }) => data),
    { enabled: Boolean(wlID) },
  )

  useEffect(() => {
    if (isError) {
      toast.error(`${_key}: ${error.message}`)
    }
  }, [isError, error])

  return [isLoading, data]
}

export const useWlCuName = (_wl, _customer) => {
  const _key = 'Get Client Names'
  const { isError, error, data: { wl_company = '', cu_company = '' } = {} } = useQuery(
    [_key, _wl, _customer],
    () =>  getAxios().get('/whitelabel/name', { params: { _wl, _customer } }).then(({ data }) => data),
    { enabled: Boolean(_wl && _customer) },
  )

  useEffect(() => {
    if (isError) {
      toast.error(`${_key}: ${error.message}`)
    }
  }, [isError, error])

  return [wl_company, cu_company]
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

// get wl name helper
export const getWlName = (wlList, wlID) => {
  const wl = wlList.find(({ whitelabelid }) => Number(whitelabelid) === Number(wlID))
  return wl?.company
}

// get cu name helper
export const getCuName = (cuList, cuID) => {
  const cu = cuList.find(({ agencyid }) => Number(agencyid) === Number(cuID))
  return cu?.companyname
}
